import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-8 pt-28 md:pt-40 pb-24 flex flex-col items-center justify-center text-center">
      <span className="text-6xl md:text-8xl font-heading font-extrabold text-primary-500/30 select-none">404</span>
      <h1 className="mt-4 text-2xl md:text-3xl font-heading font-bold text-foreground-950">页面不存在</h1>
      <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md leading-relaxed">
        你访问的页面可能已被移动或暂时不可用。可以返回首页，或前往视频分类继续浏览。
      </p>
      <p className="mt-2 text-xs text-foreground-500 font-mono break-all">{location.pathname}</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-950 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line w-5 h-5 flex items-center justify-center" />
          返回首页
        </Link>
        <Link
          to="/category/电影"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300/70 hover:border-primary-500 text-foreground-800 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-movie-2-line w-5 h-5 flex items-center justify-center" />
          浏览视频分类
        </Link>
      </div>
    </div>
  );
}